import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRouteSchema } from "@/seo/schema";

const SCRIPT_ATTR = "data-seo-jsonld";

/**
 * Route-aware Schema.org JSON-LD manager.
 *
 * Kept fully separate from the Open Graph / Twitter runtime mutation so the
 * two concerns never share state. It removes any previously injected graph and
 * writes the graph for the current route.
 */
export default function SeoSchemaManager(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .querySelectorAll(`script[${SCRIPT_ATTR}="route"]`)
      .forEach((node) => node.remove());

    const schemas = getRouteSchema(pathname);
    if (schemas.length === 0) {
      return;
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute(SCRIPT_ATTR, "route");
    script.text = JSON.stringify(
      schemas.length === 1 ? schemas[0] : { "@context": "https://schema.org", "@graph": schemas },
    );
    document.head.appendChild(script);
  }, [pathname]);

  return null;
}